import React from 'react'
import { Div, Tab, Tabs } from '@sendoutcards/quantum-design-ui'
import { useAccount } from 'src/hooks'
import AffiliateLinks from './AffiliateLinks'
import { FlexRow } from 'src/styled'

interface VerticalTabsProps {
  toggleAlert: () => void
}

export const tabs = [
  {
    title: 'SendOutCards',
    domainName: 'SendOutCards',
    tabKey: 'one',
    id: 'soc',
  },
  {
    title: 'Bella Cadeaux',
    domainName: 'BellaCadeaux',
    tabKey: 'two',
    id: 'bella',
  },
  {
    title: 'Blue 42 for Life',
    domainName: 'Blue42ForLife',
    tabKey: 'three',
    id: 'blue42',
  },
  {
    title: 'Greener Still',
    domainName: 'GreenerStill',
    tabKey: 'four',
    id: 'greenerstill',
  },
  {
    title: 'Prompting U',
    domainName: 'PromptingU',
    tabKey: 'five',
    id: 'promptingu',
  },
  {
    title: 'Stream Marketing',
    domainName: 'streammarketing',
    tabKey: 'six',
    id: 'streammrkt',
  },
  {
    title: 'Stream Virtual Assistant',
    domainName: 'streamvirtualassistant',
    tabKey: 'seven',
    id: 'streamva',
  },
]

const VerticalTabs: React.FC<VerticalTabsProps> = props => {
  const { toggleAlert } = props
  const account = useAccount()
  const gid = account.genealogyId.toString()
  return (
    <FlexRow>
      <Tabs defaultActiveKey={'one'} height="400px">
        {tabs.map((tab, index) => (
          <Tab key={`tab_${index}`} tabKey={tab.tabKey} title={tab.title}>
            <Div width="100%">
              <AffiliateLinks
                isSoc={tab.title === 'SendOutCards'}
                domainName={tab.domainName}
                slug={
                  account.storefront ? (account.storefront.slug as string) : gid
                }
                onCopy={toggleAlert}
              />
            </Div>
          </Tab>
        ))}
      </Tabs>
    </FlexRow>
  )
}

export default VerticalTabs
